import React, { useState } from 'react'
import { FormGroup, Input } from 'reactstrap';
import api from '../../services/api';

const Actions = ({ item, fiscal_year_id, gnid, isCompleted }) => {

  const [remarksValue, setRemarksValue] = useState(item.qa_remarks || '')
  const [qa_option, setQaOption] = useState(item.qa_option || 0)

  const handleChangeOptions = (e) => {
    const value = e.target.value;
    setQaOption(value)
    submitQA(value, remarksValue)
  }

  const handleRemarksChange = (e) => {
    const value = e.target.value;
    setRemarksValue(value)
  }

  const handleRemarksSubmit = (e) => {
    const value = e.target.value;
    setRemarksValue(value)
    submitQA(qa_option, value)
  }

  const submitQA = async (option, remarks) => {
    const reqBody = {
      fiscal_year_id: fiscal_year_id,
      gnid: gnid,
      question_id: item.id,
      qa_option: option,
      qa_remarks: remarks,
    }
    const res = await api.submitQA(reqBody)
    if (res && res.code === 200) {
      console.log("Success")
    }
  }

  return (
    <>
      <td>
        <FormGroup>
          <Input type="select" placeholder="" disabled={isCompleted} name="qa_option" id="qa_option" value={qa_option} onChange={handleChangeOptions}>
            <option value={0} disabled selected></option>
            {
              item.options.length > 0 &&
              item.options.map((option, index) => {
                return (
                  <option key={option.id} value={option.id} >{option.name}</option>
                );
              })
            }
          </Input>
        </FormGroup>
      </td>
      <td ><textarea disabled={isCompleted} className="form-control w-100" value={remarksValue} name={`remarks${item.id}`} onChange={handleRemarksChange} onBlur={handleRemarksSubmit} /></td>
    </>
  )
}

export default Actions
